/**
 * Svelte Custom Elements 自動登録
 * パーツライブラリ準拠コンポーネントを自動的に登録
 */

// customElements.define の重複登録を防止するパッチ
const originalDefine = customElements.define.bind(customElements);
customElements.define = function(name, constructor, options) {
  if (customElements.get(name)) return;
  originalDefine(name, constructor, options);
};

const modules = import.meta.glob('./**/*.svelte', { eager: true });

const componentNames = Object.keys(modules).map(path => path.replace('./', '').replace('.svelte', ''));
console.log('Svelte Custom Elements registered:', componentNames);
